import { BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import { Home,Gallery } from './pages';


function App() {
  return (
    <div className = "App">
      <Router>
          <Switch>
            <Route exact path = '/'>
              <Home />
            </Route>
          </Switch>
          <Switch>
            <Route exact path = '/Gallery'>
              <Gallery />
            </Route>
          </Switch>
      </Router>
    </div>
  );
}


export default App;
